import { motion } from "framer-motion";
import { CheckCircle2, ArrowUpRight } from "lucide-react";
import { POLISH_IMAGE } from "../data";
import { useI18n } from "../i18n";

export const Polish = ({ onQuote }) => {
  const { t } = useI18n();
  const bullets = t("polish.bullets");

  return (
    <section id="polissage" data-testid="polish-section" className="relative py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("polish.tag")}</span>
            <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-none">
              {t("polish.title1")} <span className="text-cyan neon-text-glow">{t("polish.title2")}</span>
            </h2>
            <p className="text-neutral-400 font-light mt-5 text-lg">{t("polish.subtitle")}</p>

            <ul className="mt-8 space-y-4">
              {bullets.map((b, i) => (
                <li key={i} data-testid={`polish-bullet-${i}`} className="flex items-start gap-3">
                  <CheckCircle2 size={20} className="text-cyan shrink-0 mt-0.5" />
                  <span className="text-neutral-200 font-light">{b}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="polish-cta"
              onClick={onQuote}
              className="mt-9 inline-flex items-center gap-3 text-black font-medium text-base px-7 py-4 rounded-full neon-glow hover:brightness-110 transition-all duration-300"
              style={{ backgroundColor: "#C9A96A" }}
            >
              {t("polish.cta")}
              <ArrowUpRight size={18} />
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative overflow-hidden rounded-3xl border border-cyan-500/20"
          >
            <img src={POLISH_IMAGE} alt={t("polish.title2")} loading="lazy" className="w-full h-full object-cover aspect-[4/5]" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
